package org.lennycodes.hldi.components

object Routes {
    val admin = "/admin"
    const val about = "/admin-about"
    val projects = "/admin-projects"
    const val events = "/admin-events"
    const val gallery = "/admin-gallery"
    const val blog = "/admin-blog"
    const val resources = "/admin-resources"
}